<template>
  <div id="image-wrapper" class="row">
    <div class="col px-0">
      <img src="@/assets/crane-placeholder.png" class="w-100">  
    </div>
  </div>
</template>

<script>
export default {
  name: 'pageImage'
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layout/PageImage.vue